import { styled } from "@mui/material"
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker"

export const DatePicker = styled(MuiDatePicker)(({ theme }) => ({
    "& .MuiOutlinedInput-root": {
        borderRadius: 12,
        "& .MuiSvgIcon-root": {
            color: theme.palette.text.secondary,
        },
    },
}))